import React from 'react';
import {
  useTranslation,
} from 'react-i18next';
import {
  Link,
  useOutletContext,
} from 'react-router-dom';

import {
  formatNoticeDate,
  getNoticeOverview,
  getNoticeTitle,
} from '../config/updateNoticeConfig';



import './UpdateNoticePage.css';


function OverviewLines({
  overview,
}) {
  
  const lines = String(
    overview || '',
  )
    .split(/\r?\n/)
    .map(
      (line) =>
        line.trim(),
    )
    .filter(Boolean);

  if (
    lines.length === 0
  ) {
    return <span>-</span>;
  }

  return (
    <ul>
      {lines
        .slice(0, 3)
        .map(
          (
            line,
            index,
          ) => (
            <li
              key={`${line}-${index}`}
            >
              {line}
            </li>
          ),
        )}
    </ul>
  );
}

export default function UpdateNoticeListPage() {
  const {
    filteredNotices,
    loading,
    error,
  } = useOutletContext();
  const { t } = useTranslation('app');
  return (
    <>
      {loading && (
        <div
          className="
      updatenotice-state-card
      updatenotice-loading
    "
          role="status"
          aria-live="polite"
        >
          <span
            className="updatenotice-loading-spinner"
            aria-hidden="true"
          />

          <span className="updatenotice-loading-text">
            {t(
              'updatenotices.detail.loading',
            )}
          </span>
        </div>
      )}

      {!loading &&
        error && (
          <div className="updatenotice-state-card error">
            {error}
          </div>
        )}

      {!loading &&
        !error &&
        filteredNotices.length ===
          0 && (
          <div className="updatenotice-state-card">
            {t('updatenotices.detail.loadFailed')}
          </div>
        )}

      {!loading &&
        !error &&
        filteredNotices.length >
          0 && (
          <div className="updatenotice-table-card">
            <div className="updatenotice-table-scroll">
              <table className="updatenotice-table">
                <thead>
                  <tr>
                    <th>No.</th>

                    <th>
                      {t('updatenotices.detail.title')}
                    </th>

                    <th>
                      {t('updatenotices.detail.program')}
                    </th>

                    <th>
                      {t('updatenotices.detail.platform')}
                    </th>

                    <th>
                      {t('updatenotices.detail.version')}
                    </th>

                    <th>
                      {t('updatenotices.detail.date')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {filteredNotices.map(
                    (
                      notice,
                      index,
                    ) => (
                      <tr
                        key={`${notice.seq}-${notice.title}-${index}`}
                      >
                        <td>
                          {notice.seq ||
                            index +
                              1}
                        </td>

                        <td>
                          <Link
                            to={`/updatenotices/${notice.seq}`}
                            className="updatenotice-title-link"
                          >
                            {getNoticeTitle(
                              notice,
                            )}
                          </Link>

                          <div className="updatenotice-overview">
                            <OverviewLines
                              overview={
                                getNoticeOverview(
                                  notice,
                                )
                              }
                            />
                          </div>
                        </td>

                        <td>
                          {notice.program ||
                            '-'}
                        </td>

                        <td>
                          {notice.platform ||
                            '-'}
                        </td>

                        <td>
                          {notice.version ||
                            '-'}
                        </td>

                        <td>
                          {formatNoticeDate(
                            notice.date,
                          )}
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
    </>
  );
}